import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { ModalCookiePreferenceComponent } from '../modal-cookie-preference/modal-cookie-preference.component';
import { ResolveTeamsService } from '@app/core/services/resolvers/resolve-teams.service';
import { Team } from '@app/shared/models/team';
import { DialogService } from '@ngneat/dialog';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { hostnameIsFromMainDomain } from '@app/shared/helpers/location';

@Component({
    selector: 'app-smash-burger-menu-mobile',
    templateUrl: './smash-burger-menu-mobile.component.html',
    styleUrls: ['./smash-burger-menu-mobile.component.scss']
})
export class SmashBurgerMenuMobileComponent implements OnDestroy {

    subscriptions: Subscription[] = [];
    isLoggedIn: boolean;
    selectedTeam: Team;
    isMainDomain: boolean;
    burgerToggled = false;
    version: string;

    @Output() menuToggle: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private resolveTeamsService: ResolveTeamsService,
        private dialog: DialogService,
    ) {
        this.isMainDomain = hostnameIsFromMainDomain(window.location.hostname);
        this.version = environment.version;

        this.subscriptions.push(
            this.resolveTeamsService.resolve().subscribe((res) => {
                this.isLoggedIn = res.isLoggedIn;
                this.selectedTeam = res.selectedTeam;
            })
        );
    }

    openCookiePreference(event) {
        this.toggleBurgerMenu(event);
        this.dialog.open(ModalCookiePreferenceComponent, {
            closeButton: false,
            enableClose: false,
            size: 'sm',
            width: '600px',
            data: {
                cancelable: true,
            },
        });
    }

    toggleBurgerMenu(event) {
        this.burgerToggled = !this.burgerToggled;
        this.menuToggle.emit({ toggled: this.burgerToggled, event })
        event.stopPropagation();
        return false;
    }

    ngOnDestroy() {
        this.burgerToggled = false;
    }
}
